import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    /** 获取预产期天数信息列表 **/
    GET_BIRTHDAY_LIST(data) {
        controller='Birth';
        action='GetBirthdayList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取预产期提醒天数类型信息列表 **/
    GET_NOTICE_TYPE_LIST(data) {
        controller='Birth';
        action='GetNoticeTypeList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增繁育信息 **/
    ADD_BIRTH(data) {
        controller='Birth';
        action='AddBirth';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 编辑繁育信息 **/
    EDIT_BIRTH(data) {
        controller='Birth';
        action='EditBirth';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取繁育信息列表 **/
    GET_BIRTH_LIST(data) {
        controller='Birth';
        action='GetBirthList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除繁育信息 **/
    DEL_BIRTH(data) {
        controller='Birth';
        action='DelBirth';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 完成繁育信息 **/
    FINISH_BIRTH(data) {
        controller='Birth';
        action='FinishBirth';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取繁育信息列表 **/
    GET_BIRTH_INFOS(data) {
        controller='Birth';
        action='GetBirthdayInfos';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

}